import { Navigate, useLocation } from 'react-router-dom'

import { isAuthenticated } from '../pages/auth/login/auth'
import { tokenStorage } from '../utils'

const PublicProtected = ({ children }) => {
  const location = useLocation()

  if (isAuthenticated()) {
    return <Navigate to="/dashboard" state={{ from: location }} replace />
  }

  // Stale tokens in storage can cause redirect loops between /login and /dashboard.
  // Clear them so AuthProtected stops bouncing back here.
  if (tokenStorage.getAccessToken()) {
    tokenStorage.clearTokens()
  }

  return children
}

export { PublicProtected }
